module.exports = __webpack_public_path__ + "static/img/bali-bird-park-bg.f403e26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/content/bali-bird-park-bg.jpg
// module id = cw5M
// module chunks = 0